<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Cadastro de receita" posicao="left" />

    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir Receita" tamanho_modal="modal-xl" @click_bt_modal="click_bt_modal" :exibe_botao="true">

      <template #default>
        <form @submit.prevent="register" enctype="multipart/form-data" id="cad_forma_pagamento">
          <fieldset>
            <div class="row">
              <InputSelect placeholder="" label="Eleitor *" api_link="user/list_select"
                tamanho="sm" classDiv="col-lg-6 col-xl-4" name="id_usuario" ref="id_usuario"
                v-model="id_usuario" />

              <input-money label="Valor *" tamanho="sm" classDiv="col-lg-6 col-xl-4" nome="valor" ref="valor"
                v-model="valor" />

              <InputSelect placeholder="" label="Forma de pagamento *" api_link="finance/payment_mode/list_select"
                tamanho="sm" classDiv="col-lg-6 col-xl-4" name="id_forma_pagamento" ref="id_forma_pagamento"
                v-model="id_forma_pagamento" />

              <InputText placeholder="" label="Data da entrada *" tipo="date" tamanho="sm" classDiv="col-lg-6 col-xl-4"
                nome="data_entrada" ref="data_entrada" v-model="data_entrada" />

              <InputText placeholder="" label="Observações" tamanho="sm" classDiv="col-lg-6 col-xl-4" nome="observacao"
                ref="observacao" v-model="observacao" />

              <input type="submit" class="d-none" value="">
            </div>
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <input type="submit" @click.prevent="register" value="Salvar" class="btn-salvar btn btn-primary">
          <Spinner :visivel="false" id="loading" />
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="" tamanho_modal="modal-md"
      :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        Tem certeza que deseja deletar a receita <strong>"{{ titulo_delete }}"</strong>?
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i>
            Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData"
      :ordem_tabela="[{ name: 'data_entrada', dir: 'desc' }, { name: 'id_usuario', dir: 'asc' }]" dadosAjax=""
      :btnEdit="true" :btnDelete="true" :ativa_placeholder="ativa_placeholder" :columns="colunas"
      @edit_status="edit_status" @edit_row="dados_editar" @delete_row="deletar_dados"
      modal_target_delete="#modal_delete"></TabelaDatatable>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import TituloGrande from '../../components/TituloGrande.vue'
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import InputText from '@/components/form/InputText.vue';
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';
import { bloqueia_campos } from '@/assets/js/functions'
import { cadastrar, editar_status, deletar } from '@/assets/js/requests'
import { toastr } from '@/plugins/toast';
import InputTextMask from '@/components/form/InputTextMask.vue';
import InputSelect from '@/components/form/InputSelect.vue';
import InputMoney from '../../components/form/InputMoney.vue';
import { data_hoje } from '@/assets/js/functions'

export default {
  components: { TituloGrande, Modal, TabelaDatatable, InputText, InputTextMask, InputSelect, InputMoney },
  name: 'CadFinancasFormaPagamento',
  data() {
    return {
      auth: AuthStore(),
      id_delete: Number,
      id_dados: null,
      titulo_delete: String,
      id_usuario: '',
      valor: '0,00',
      id_forma_pagamento: '',
      data_entrada: data_hoje(),
      observacao: '',
      dadosData: '',
      colunas: [
        { data: 'id_usuario', title: 'Eleitor', width: '20%' },
        { data: 'valor', title: 'Valor', width: '20%' },
        { data: 'id_forma_pagamento', title: 'Forma de pagamento', width: '20%' },
        { data: 'data_entrada', title: 'Data do lançamento', width: '20%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '10%' },
      ],
      textoBtnCadastro: 'Cadastro de Categoria de Notícia',
      ativa_placeholder: Boolean,
    }
  },
  mounted() {
    this.listagemTabela();
  },
  methods: {
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.get('finance/receive/list', { Authorization: this.auth.token })
      this.ativa_placeholder = false
    },
    async register(e) {
      e.preventDefault();
      if (!this.id_usuario) {
        toastr.alerta("Digite o nome da receita")
        return false;
      }
      const formu = document.querySelector("#cad_forma_pagamento")
      const dados = new FormData(formu)
      if (this.id_dados > 0) {
        dados.append('id', this.id_dados)
      }
      const registro = await cadastrar('finance/receive/register', dados);
      if (registro) {
        if (!this.id_dados) {
          this.limpa_campos()
        }
        this.listagemTabela()
      }
    },
    async edit_status(dados) {
      const edit = await editar_status('finance/receive/change_status', dados);
      if (edit) {
        this.listagemTabela()
      } else {
        // this.$router.push('/login')
      }
    },
    async dados_editar(dados) {
      bloqueia_campos()

      var dadosEdit = await api.get('finance/receive/list/' + dados.rowData.id, { Authorization: this.auth.token })
      this.id_dados = dados.rowData.id;
      this.id_usuario = dadosEdit.id_usuario;
      this.valor = dadosEdit.valor;
      this.id_forma_pagamento = dadosEdit.id_forma_pagamento;
      this.data_entrada = dadosEdit.data_entrada;
      this.observacao = dadosEdit.observacao;

      document.querySelector("#btn_modal_cadastrar").click()
      bloqueia_campos(false)
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.id_usuario = '';
      this.valor = '0.00'
      this.id_forma_pagamento = ''
      this.data_entrada = data_hoje()
      this.observacao = ''
      this.id_dados = null;
    },
    click_bt_modal() {
      if (this.id_dados > 0) {
        this.textoBtnCadastro = 'Editando receita: ' + this.id_usuario
      } else {
        this.textoBtnCadastro = 'Cadastrar receita'
      }
    },
    deletar_dados(dados) {
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.id_usuario
    },
    async deletar() {
      const delet = await deletar('finance/receive/delete', { id: this.id_delete });
      if (delet) {
        this.listagemTabela()
      }
    }
  },
}
</script>

<style></style>